module.exports = __webpack_public_path__ + "img/ProcessNotrun.518d50ff.svg";